import React from "react";

import { MenuItemVariantOffer } from "@/custom-types/MenuItem";
import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import { getDispensaryUrl } from "@/utils/dispensaryUrls";

import SmartOfferCard from "@/components/SmartOfferCard";

type Props = {
  offers: MenuItemVariantOffer[];
  dispensarySlug?: string;
  setModalIsVisible: (isVisible: boolean) => void;
  buttonRef: React.MutableRefObject<null>;
};

const Offers: React.FC<Props> = ({
  offers,
  dispensarySlug,
  buttonRef,
  setModalIsVisible,
}) => {
  const countryCode = useDomainCountryCode();

  const dealLink = getDispensaryUrl({
    countryCode,
    slug: dispensarySlug || "",
    tab: "menu",
  });

  return (
    <div className="my-lg md:max-w-[322px]">
      <SmartOfferCard
        offers={offers}
        dealLink={dealLink}
        onClickAll={() => setModalIsVisible(true)}
        buttonRef={buttonRef}
        gaCategory="Menu Item Details"
      />
    </div>
  );
};

export default Offers;
